import type { Mismatch } from "../types";

interface FieldHintProps {
  /** Optional id so inputs can reference this hint via aria-describedby. */
  id?: string;
  error: string | null;
  isPrefilled: boolean;
  mismatch?: Mismatch;
}

/**
 * Renders the dynamic state message below a form field. Priority:
 * - Error (red) — validation failed
 * - Mismatch (gold) — user changed a pre-filled value
 * - Pre-filled (green) — value came from the proposal
 *
 * Static helper text (e.g. "Auto-populated from Zip Code") is rendered
 * separately by the field components above the input — it sets context
 * BEFORE the user interacts and shouldn't compete with these states.
 */
export function FieldHint({ id, error, isPrefilled, mismatch }: FieldHintProps) {
  if (error) {
    return <p id={id} className="text-xs text-danger mt-1">{error}</p>;
  }

  if (mismatch) {
    return (
      <p id={id} className="text-xs text-warning mt-1">
        Differs from proposal: {mismatch.original}
      </p>
    );
  }

  if (isPrefilled) {
    return <p id={id} className="text-xs text-success mt-1">✓ Pre-filled from proposal</p>;
  }

  return null;
}
